module.exports = __webpack_public_path__ + "img/Selector.9cc343b3.svg";